(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producer-carousel"] && !Shopify.designMode) return;
  try {
    
class ProducerCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.count = this.cards().length;
    this.cloneLoop();
    this.index = this.count > 1 ? this.count : 0;
    this.drag = null;
    this.suppressClick = false;
    this.pendingFocus = null;

    this.onClick = (event) => {
      if (this.suppressClick) {
        this.suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (event.target.closest('[data-next]')) {
        event.preventDefault();
        this.move(1);
        return;
      }

      if (event.target.closest('[data-prev]')) {
        event.preventDefault();
        this.move(-1);
        return;
      }

      const select = event.target.closest('[data-select]');
      if (!select) return;
      const card = select.closest('[data-card]');
      const index = this.cards().indexOf(card);
      if (index < 0 || index === this.index) return;
      this.index = index;
      this.render(true);
      this.restoreFocus();
    };

    this.onKeydown = (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.move(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move(-1);
      }
    };

    this.onPointerDown = (event) => {
      if (event.button !== 0) return;
      if (event.target.closest('[data-next], [data-prev], a')) return;
      this.drag = {
        x: event.clientX,
        pointerId: event.pointerId,
        dragged: false,
      };
    };

    this.onPointerMove = (event) => {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;
      if (Math.abs(event.clientX - this.drag.x) > 8) this.drag.dragged = true;
    };

    this.onPointerUp = (event) => {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;
      const distance = event.clientX - this.drag.x;
      const dragged = this.drag.dragged && Math.abs(distance) > 48;
      this.drag = null;
      if (!dragged) return;
      this.suppressClick = true;
      this.move(distance < 0 ? 1 : -1);
    };

    this.onBlockSelect = (event) => {
      const card = event.target?.closest?.('[data-card]');
      if (!card || card.hasAttribute('data-clone') || !this.contains(card)) return;
      const logical = Number(card.dataset.logical);
      if (Number.isNaN(logical)) return;
      this.index = this.count > 1 ? this.count + logical : logical;
      this.render(false);
    };

    this.onTransitionEnd = (event) => {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      this.animating = false;
      this.settle();
    };

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('pointerdown', this.onPointerDown);
    this.addEventListener('pointermove', this.onPointerMove);
    this.addEventListener('pointerup', this.onPointerUp);
    this.addEventListener('pointercancel', this.onPointerUp);
    this.track?.addEventListener('transitionend', this.onTransitionEnd);
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.animating = false;
    this.observer = new ResizeObserver(() => {
      if (this.animating) return;
      this.render(false);
    });
    this.observer.observe(this);
    this.render(false);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('pointerdown', this.onPointerDown);
    this.removeEventListener('pointermove', this.onPointerMove);
    this.removeEventListener('pointerup', this.onPointerUp);
    this.removeEventListener('pointercancel', this.onPointerUp);
    this.track?.removeEventListener('transitionend', this.onTransitionEnd);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.observer?.disconnect();
  }

  cards() {
    return [...this.querySelectorAll('[data-card]')];
  }

  cloneLoop() {
    if (!this.track || this.count < 2) return;
    const originals = [...this.track.children];
    const copy = (source) => {
      const clone = source.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      [...clone.attributes].forEach((attr) => {
        if (attr.name.includes('shopify')) clone.removeAttribute(attr.name);
      });
      clone.querySelectorAll('button, a').forEach((element) => {
        element.tabIndex = -1;
      });
      return clone;
    };
    this.track.prepend(...originals.map(copy));
    this.track.append(...originals.map(copy));
  }

  logical() {
    if (this.count < 1) return 0;
    return ((this.index % this.count) + this.count) % this.count;
  }

  step() {
    const card = this.cards()[0];
    if (!card || !this.track) return 0;
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card.offsetWidth + gap;
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  move(delta) {
    if (this.count < 2) return;
    this.pendingFocus = document.activeElement?.matches?.('[data-next]')
      ? 'next'
      : document.activeElement?.matches?.('[data-prev]')
        ? 'prev'
        : null;
    this.settle();
    this.index += delta;
    this.render(true);
    this.restoreFocus();
  }

  settle() {
    if (this.count < 2) return;
    const normalized = this.count + this.logical();
    if (this.index === normalized) return;
    const focused = document.activeElement;
    const focusSelector = focused?.matches?.('[data-prev]')
      ? '[data-prev]'
      : focused?.matches?.('[data-next]')
        ? '[data-next]'
        : null;
    this.index = normalized;
    this.classList.add('is-settling');
    this.track.classList.add('is-instant');
    this.track.style.transform = `translate3d(${-this.index * this.step()}px, 0, 0)`;
    this.syncState(false);
    this.offsetWidth;
    this.classList.remove('is-settling');
    if (focusSelector && focused && this.contains(focused)) {
      this.cards()[this.index]?.querySelector(focusSelector)?.focus();
    }
  }

  restoreFocus() {
    if (!this.pendingFocus) return;
    const selector = this.pendingFocus === 'prev' ? '[data-prev]' : '[data-next]';
    this.pendingFocus = null;
    this.cards()[this.index]?.querySelector(selector)?.focus();
  }

  render(animate) {
    const cards = this.cards();
    if (!this.track || this.count === 0) return;

    const motion = animate && !this.prefersReducedMotion();
    this.animating = motion;
    if (motion) {
      this.track.classList.remove('is-instant');
      this.offsetWidth;
    } else {
      this.classList.add('is-settling');
      this.track.classList.add('is-instant');
    }

    this.track.style.transform = `translate3d(${-this.index * this.step()}px, 0, 0)`;
    this.syncState(motion);

    if (!motion) {
      this.offsetWidth;
      this.classList.remove('is-settling');
      this.settle();
    }
  }

  syncState(announce) {
    const cards = this.cards();
    const logical = this.logical();
    const template = this.dataset.position || '';
    const label = template
      .replace('__CURRENT__', String(logical + 1))
      .replace('__TOTAL__', String(this.count));

    cards.forEach((card, index) => {
      const active = index === this.index;
      card.classList.toggle('is-active', active);
      const select = card.querySelector('[data-select]');
      if (!select || card.hasAttribute('data-clone')) return;
      select.tabIndex = active ? -1 : 0;
      select.setAttribute('aria-hidden', active ? 'true' : 'false');
    });

    this.querySelectorAll('[data-count]').forEach((node) => {
      node.textContent = label;
    });

    if (!announce) return;
    const status = this.querySelector('[data-status]');
    const title = cards[this.index]?.dataset.title || '';
    if (status) status.textContent = title ? `${label}. ${title}` : label;
  }
}

if (!customElements.get('producer-carousel')) {
  customElements.define('producer-carousel', ProducerCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
